export interface Message {
  messageId: number;

  from: string;

  createdDate: number;
  subject: string;
  message: string;

  isBeingDismissed: boolean;
  isUnread: boolean;
}
